var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useMemo, useState } from 'react';
import { API, APIMethod, Endpoints } from '@brg/api';
import { useDispatch } from 'react-redux';
import { addLongReadPost } from '../actions/addLongReadPost';
import useCommonProps from './useCommonProps';
import { computeVoteCollection } from '../constants/computeVote';
export var useVotesCollection = function () {
    var _a = useState(), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(), error = _b[0], setError = _b[1];
    var dispatch = useDispatch();
    var _c = useState({}), response = _c[0], setResponse = _c[1];
    var _d = useState(), paging = _d[0], setPaging = _d[1];
    var _e = useState(), raw = _e[0], setRaw = _e[1];
    var _f = useState(Date.now()), time = _f[0], setTime = _f[1];
    var votesContent = useCommonProps().votesContent;
    var fetchCollectionData = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/pools/GetByParentEntity')
                        .addQuery('parentEntityId', projectId)
                        .addQuery('parentEntityType', 'project')
                        .get()
                        .send()
                        .then(function (r) { return r.json(); })
                        .then(function (r) {
                        return setResponse(__assign({ projectId: projectId }, computeVoteCollection(r)));
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if ((votesContent === null || votesContent === void 0 ? void 0 : votesContent.isCollectionVote) && (votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId) !== '') {
            fetchCollectionData(votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId);
        }
    }, [votesContent, time]);
    useEffect(function () {
        if (raw && !error) {
            setResponse(API.toLang(raw, 'en'));
            var rawResponse = raw;
            setPaging(rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.paging);
        }
        else {
            setResponse(undefined);
        }
    }, [raw, error]);
    useEffect(function () {
        if ((response && raw) || error) {
            setIsLoading(false);
        }
    }, [response, raw, error]);
    if (!((votesContent === null || votesContent === void 0 ? void 0 : votesContent.isCollectionVote) && (votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId) !== '')) {
        return null;
    }
    return useMemo(function () { return [response, setTime, isLoading, error]; }, [response, setTime, isLoading, error]);
};
//# sourceMappingURL=useVoteCollection.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useMemo, useState } from 'react';
import { API, APIMethod, Endpoints } from '@brg/api';
import { useDispatch } from 'react-redux';
import { addLongReadPost } from '../actions/addLongReadPost';
import useCommonProps from './useCommonProps';
import { computeVoteCollection } from '../constants/computeVote';
export var useVotesCollection = function () {
    var _a = useState(), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(), error = _b[0], setError = _b[1];
    var dispatch = useDispatch();
    var _c = useState({}), response = _c[0], setResponse = _c[1];
    var _d = useState(), paging = _d[0], setPaging = _d[1];
    var _e = useState(), raw = _e[0], setRaw = _e[1];
    var _f = useState(Date.now()), time = _f[0], setTime = _f[1];
    var votesContent = useCommonProps().votesContent;
    var fetchCollectionData = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, API.request()
                        .endpoint(Endpoints.geograffee)
                        .url('/api/pools/GetByParentEntity')
                        .addQuery('parentEntityId', projectId)
                        .addQuery('parentEntityType', 'project')
                        .get()
                        .send()
                        .then(function (r) { return r.json(); })
                        .then(function (r) {
                        return setResponse(__assign({ projectId: projectId }, computeVoteCollection(r)));
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if ((votesContent === null || votesContent === void 0 ? void 0 : votesContent.isCollectionVote) && (votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId) !== '') {
            fetchCollectionData(votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId);
        }
    }, [votesContent, time]);
    useEffect(function () {
        if (raw && !error) {
            setResponse(API.toLang(raw, 'en'));
            var rawResponse = raw;
            setPaging(rawResponse === null || rawResponse === void 0 ? void 0 : rawResponse.paging);
        }
        else {
            setResponse(undefined);
        }
    }, [raw, error]);
    useEffect(function () {
        if ((response && raw) || error) {
            setIsLoading(false);
        }
    }, [response, raw, error]);
    if (!((votesContent === null || votesContent === void 0 ? void 0 : votesContent.isCollectionVote) && (votesContent === null || votesContent === void 0 ? void 0 : votesContent.projectId) !== '')) {
        return null;
    }
    return useMemo(function () { return [response, setTime, isLoading, error]; }, [response, setTime, isLoading, error]);
};
//# sourceMappingURL=useVoteCollection.js.map